<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <AdvancedTrainingCheckout :combos="combos" :variant="A" :includeSubscription="includeSubscription"/>
  </b-container>
</template>
<style>

</style>

<script>
import AdvancedTrainingCheckout from "@/components/checkout/advancedtraining/AdvancedTrainingCheckout.vue";

export default {
  title: 'Advanced Training Checkout',
  name: "AdvancedTraining",
  props: ["combos", "includeSubscription"],
  components: {
    AdvancedTrainingCheckout
  },
  computed: {
  },
};
</script>
